var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Ellipse_101"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Ellipse-101","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("circle",{"id":"Ellipse_101","cx":"11.965","cy":"11.965","r":"11.965"})))]);
}

Circle.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Circle;

Circle.default = Circle;
